// A wallet pass is only useful on the phone that will be scanned at the door,
// so the add buttons are hidden elsewhere. Callers that wrap the buttons in a
// heading need the same answer the buttons use, or they render an empty shell.
const userAgent = () =>
  (typeof navigator === 'undefined'
    ? ''
    : navigator.userAgent || navigator.vendor || window.opera) || ''

const platformHint = () => {
  if (typeof navigator === 'undefined') return ''
  return navigator.userAgentData?.platform || ''
}

const matchesMedia = (query) => {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false
  }
  return window.matchMedia(query).matches
}

export const isAppleWalletDevice = () => {
  if (/iPhone|iPad|iPod/i.test(userAgent())) return true
  if (/iOS|iPhone|iPad/i.test(platformHint())) return true
  // iPadOS reports a desktop Mac user agent. A touchscreen Mac has a fine
  // pointer, so require a coarse pointer as well.
  return (
    typeof navigator !== 'undefined' &&
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 1 &&
    matchesMedia('(pointer: coarse)')
  )
}

export const isGoogleWalletDevice = () =>
  /android/i.test(userAgent()) || /android/i.test(platformHint())

// In-app browsers and "desktop site" drop Android/iPhone from the user agent
// while the page is still a phone. Those visitors were seeing the wallet
// instructions with no buttons.
export const isPhoneSizedTouchDevice = () => {
  if (typeof navigator === 'undefined') return false
  const touch =
    navigator.maxTouchPoints > 0 || matchesMedia('(pointer: coarse)')
  return touch && matchesMedia('(max-width: 900px)')
}

export const showAppleWalletButton = () =>
  isAppleWalletDevice() ||
  (isPhoneSizedTouchDevice() && !isGoogleWalletDevice())

export const showGoogleWalletButton = () =>
  isGoogleWalletDevice() ||
  (isPhoneSizedTouchDevice() && !isAppleWalletDevice())

export const supportsWalletPass = () =>
  showAppleWalletButton() || showGoogleWalletButton()
